import { http } from '$lib/http';
import { API_URL } from '$lib/helpers';
import { IExpresseDeliveryResponse } from '$models';

const BASE_URL = `${API_URL}`;

export const getExpressDeliveryPdp = async (
    itemNumber?: string,
    zipcode?: string
): Promise<IExpresseDeliveryResponse | null> => {
    if (!itemNumber && !zipcode) {
        return null;
    }
    const response = await http(`${BASE_URL}/item/${itemNumber}/${zipcode}`);

    if (!response.ok) {
        return null;
    }
    const data: IExpresseDeliveryResponse = await response.json();
    return data;
};

export const getExpressDeliveryWithCoords = async (
    itemNumber?: string,
    lat?: string,
    lng?: string
): Promise<IExpresseDeliveryResponse | null> => {
    if (!itemNumber && !lat && !lng) {
        return null;
    }
    const response = await http(`${BASE_URL}/item/${itemNumber}/${lat}/${lng}`);

    if (!response.ok) {
        return null;
    }
    const data: IExpresseDeliveryResponse = await response.json();
    return data;
};

export const getSameDayDeliveryAllowed = async (
    basketId?: string,
    zipcode?: string
): Promise<IExpresseDeliveryResponse | null> => {
    if (!basketId && !zipcode) {
        return null;
    }
    const response = await http(`${BASE_URL}/basket/${basketId}/${zipcode}`);

    if (!response.ok) {
        return null;
    }
    const data: IExpresseDeliveryResponse = await response.json();
    return data;
};
